const mutationTypes = {
  SET_SELECTED_USER: 'setSelectedUser'
};

const state = {
  selectedUser: null
};

const mutations = {
  [mutationTypes.SET_SELECTED_USER]: (state, user) => state.selectedUser = user
};

const actions = {
  setSelectedUser: ({commit}, user) => {
    commit(mutationTypes.SET_SELECTED_USER, user);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
